import { formatHtml } from "@trumpf/ux.common-storybook";
import { ContentTeaserTemplate } from "./content.templates";

export default {
    title: "Website/Partial Templates/Teaser/Content",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    render: ContentTeaserTemplate.bind({}),
    args: {
        row: false,
        segmentation: "1-1",
    },
    argTypes: {
        segmentation: {
            options: ["1-1", "1-2"],
            control: { type: "radio" },
        },
        row: {
            control: { type: "boolean" },
        },
    },
};

export const Default = {};
